"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CloseButton = void 0;
var _react = _interopRequireDefault(require("react"));
require("./closebutton.scss");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const CloseButton = _ref => {
  let {
    onClick,
    className,
    iconColor = "brand-primary",
    ariaLabel
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("button", {
    className: "close-button ".concat(className || ""),
    onClick: onClick,
    "aria-label": ariaLabel
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: "fa-regular fa-xmark text-".concat(iconColor)
  }));
};
exports.CloseButton = CloseButton;